import Swiper, { Navigation, Keyboard, EffectCoverflow } from 'swiper';
import Component from '../Component';

class CoverflowSlider extends Component {
  attachEventListeners() {
    new Swiper(this.root, {
      modules: [Navigation, Keyboard, EffectCoverflow],
      effect: 'coverflow',
      loop: true,
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      slideToClickedSlide: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 150,
        modifier: 1,
        slideShadows: false,
      }
    });
  }

  componentDidMount() {
    this.attachEventListeners();
  }
}

export default CoverflowSlider;
